import {lazy} from "react"

export const Facturation = lazy(() => import("@/views/facturation/Facturation"))